import { atom, selector, selectorFamily } from "recoil";
import {
  getCard,
  getRefundReceipt,
  getSubscription,
  orderReceipt,
} from "./billing.api";
import { cardType } from "./billing.type";

export const updateCardInfo = atom({
  key: "BILLING/refresh_card_data",
  default: new Date(),
});

export const resetRefundDetail = selector({
  key: "BILLING/resetDetail",
  get: (res) => res,
  set: ({ reset }) => {
    reset(refundDetailState);
  },
});

export const refundDetailState = atom({
  key: "BILLING/refund_detail_tate",
  default: {
    uid: "",
    order: 0,
    refundReceipt: "",
    receipt: "",
    type: "",
  },
});

export const asyncCardData = selector({
  key: "BILLING/get_card_data",
  get: async ({ get }) => {
    get(updateCardInfo);

    let returnVal: cardType = {
      card_data: {
        card_code: "",
        card_name: "",
        card_number: "",
        card_type: 0,
        customer_addr: "",
        customer_email: "",
        customer_name: "",
        customer_postcode: "",
        customer_uid: "",
        inserted: 0,
        pg_id: "",
        pg_provider: "nice",
        updated: 0,
      },
      created_at: "",
    };

    try {
      returnVal = await getCard();
    } catch (e) {
      console.log(e);
    }

    return returnVal;
  },
});

export const asyncGetOrder = selectorFamily({
  key: "BILLING/get_order",
  get:
    (page: number) =>
    async ({ get }) => {
      get(updateCardInfo);
      let returnVal = {};

      try {
        returnVal = await orderReceipt({ size: 10, page });
      } catch (e) {
        console.log(e);
      }

      return returnVal;
    },
});

export const asyncGetSubscriptionState = selector({
  key: "BILLING/get_current_sub",
  get: async ({ get }) => {
    get(updateCardInfo);

    let returnVal = false;

    try {
      returnVal = (await getSubscription()).subscription;
    } catch (e) {
      console.log(e);
    }

    return returnVal;
  },
});

export const asyncGetRefundOrderDetail = selectorFamily({
  key: "BILLING/get_refund_order",
  get: (order: number) => async () => {
    let returnVal = {};

    try {
      returnVal = await getRefundReceipt(order);
    } catch (e) {
      console.log(e);
    }
    return returnVal;
  },
});
